import { type IFileType, isFileAudio } from "./fileHelpers";

export const getAudioDurationFromFile = async (file?: IFileType): Promise<number | null> => {
	if (!file) return null;

	if (!isFileAudio(file)) return null;

	if (file.duration !== undefined && !Number.isNaN(file.duration)) {
		return file.duration;
	}

	return await extractAudioDuration(file);
};

const extractAudioDuration = async (file: IFileType): Promise<number | null> => {
	return new Promise((resolve) => {
		const url = URL.createObjectURL(file);
		const audio = new Audio();

		audio.onloadedmetadata = () => {
			const duration = audio.duration;

			audio.onloadedmetadata = null;
			audio.onerror = null;

			URL.revokeObjectURL(url);
			resolve(duration);
		};

		audio.onerror = () => {
			audio.onloadedmetadata = null;
			audio.onerror = null;

			URL.revokeObjectURL(url);
			resolve(null);
		};

		audio.src = url;
		audio.load();
	});
};
